export default {
  // Steps navigation
  steps_company_info: 'Company Information',
  steps_company_document: 'Company Document',
  steps_signatory_info: 'Signatory Information',
  steps_shareholder_info: 'Shareholder/Universal Beneficial Owner Information',
  steps_account_info: 'Account Information',
  // Common
  title: 'KYC Authentication',
  yes: 'Yes',
  no: 'No',
  save_as_draft: 'Save as draft',
  upload_document: 'Upload Document',
  upload_tip: 'Please ensure that the text of the uploaded data image is clear and visible.',
  upload_format: '(Max 10MB, Format JPG, JPEG, PNG or PDF)',
  upload_format_short: 'Max 10MB, JPG/JPEG/PNG/PDF',
  to: 'to',
  // Step 1: Company Information
  company_info_subtitle: 'Select your business type',
  company_info_business_type_corporation: 'Corporation',
  company_info_business_type_sole_proprietorship: 'Sole Proprietorship',
  company_info_company_type: 'Company Type',
  company_info_legal_name_en: 'Company Name',
  company_info_registration_number: 'Company Registration Number',
  company_info_date_of_incorporation: 'Date of Incorporation',
  company_info_date_of_expiry: 'Date of Expiry for Business Corporation',
  company_info_tax_id: 'Tax Identification Number',
  company_info_registration_address: 'Business Address',
  company_info_same_business_address: 'Is the actual business address same with the registered address of the enterprise?',
  company_info_brand_name: 'Brand Name / Trade Name',
  company_info_business_website: 'Business website',
  company_info_business_scope: 'Business Scope',
  company_info_mcc: 'Merchant Category Code (MCC)',
  company_info_monthly_transaction: 'Total Amount of Monthly Transaction',
  company_info_type_of_business: 'Type of Business',
  company_info_exchange_name: 'Exchange Name',
  company_info_stock_code: 'Stock Code',
  company_info_settlement_currency: 'Settlement Currency (USD or Local Currency)',
  company_info_settlement_account_location: 'Settlement Account Location',
  company_info_settlement_account_name: 'Settlement Account Name',
  company_info_settlement_account_number: 'Settlement Account Number',
  company_info_swift_code: 'Swift Code (Required for USD Settlement)',
  company_info_settlement_account_address: 'Settlement Account Address',
  company_info_settlement_account_proof: 'Settlement Account Proof',
  company_info_placeholder_enter_legal_name: 'Enter Company Name',
  company_info_placeholder_enter_registration_number: 'Enter Company Registration Number',
  company_info_placeholder_enter_tax_id: 'Enter Tax Identification Number',
  company_info_placeholder_enter_registration_address: 'Enter Business Address',
  company_info_placeholder_enter_brand_name: 'Enter Brand Name / Trade Name',
  placeholder_enter_website: 'Enter Business Website',
  placeholder_enter_business_scope: 'Enter Business Scope',
  placeholder_enter_mcc: 'Enter Merchant Category Code',
  placeholder_enter_amount: 'Enter Monthly Transaction Amount',
  placeholder_enter_business_type: 'Enter Type of Business',
  placeholder_enter_exchange_name: 'Enter Exchange Name',
  placeholder_enter_stock_code: 'Enter Stock Code',
  company_info_placeholder_enter_swift_code: 'Enter Swift Code',
  company_info_placeholder_search: 'Search',
  company_info_placeholder_enter_address_to_search: 'Enter Address to Search',
  company_info_placeholder_enter_name_to_search: 'Enter Name to Search',
  company_info_placeholder_enter_account_address_to_search: 'Enter Account Address to Search',
  company_info_company_type_option_limited: 'Limited Company',
  company_info_company_type_option_partnership: 'Partnership',
  company_info_company_type_option_sole: 'Sole Proprietorship',
  company_info_currency_option_usd: 'USD',
  company_info_currency_option_thb: 'THB',
  company_info_currency_option_sgd: 'SGD',
  company_info_currency_option_other: 'Other',
  // extra common fields (placeholders + validation)
  phone_number: 'Phone Number',
  email: 'Email',
  full_name: 'Full Name',
  store_photo: 'Store Photo',
  placeholder_enter_phone: 'Enter Phone Number',
  placeholder_enter_email: 'Enter Email Address',
  placeholder_enter_name: 'Enter Full Name',
  placeholder_date: 'YYYY-MM-DD',
  validation_phone_required: 'Please enter phone number',
  validation_phone_invalid: 'Please input the correct phone number starting with 08',
  validation_email_required: 'Please enter your email address',
  validation_email_invalid: 'Please enter a valid email address',
  validation_full_name_required: 'Please enter full name',
  validation_upload_company_registration: 'Please upload company registration',
  validation_upload_articles: 'Please upload articles of association',
  validation_upload_tax_documents: 'Please upload tax documents',
  validation_upload_business_permit: 'Please upload business permit',
  // Step 2: Company Document
  company_document_articles_of_association: 'Articles of Association',
  company_document_registration_certificate: 'Company Registration Certificate',
  company_document_tax_documents: 'Tax Documents',
  company_document_business_permit: 'Business Permit',
  company_document_license_permit: 'License Permit',
  company_document_annual_report: 'Annual Audit Documents',
  company_document_other_documents: 'Other Documents',
  // Step 3: Signatory Information
  signatory_info_subtitle: 'Select ID Type',
  signatory_info_id_type_etc: 'Etc.',
  signatory_info_id_type_passport: 'Passport',
  signatory_info_nationality: 'Nationality',
  signatory_info_id_type: 'Type of document',
  signatory_info_legal_name_en: 'Full Name',
  signatory_info_first_name: 'First Name',
  signatory_info_middle_name: 'Middle Name',
  signatory_info_last_name: 'Last Name',
  signatory_info_position: 'Position',
  signatory_info_date_of_birth: 'Date of Birth',
  signatory_info_residential_address: 'Residential Address',
  signatory_info_id_photo: 'ID Photo',
  signatory_info_taxpayer_identity: 'Taxpayer Identity',
  signatory_info_authorization_letter: 'Authorization Letter',
  signatory_info_id_number: 'ID Number',
  signatory_info_id_photo_front: 'ID Photo（Front）',
  signatory_info_id_photo_back: 'ID Photo（Back）',
  placeholder_enter_id_number: 'Enter ID Number',
  validation_id_number_required: 'Please enter ID number',
  validation_id_number_format: 'ID Number must contain only letters and numbers',
  validation_document_type_required: 'Please select document type',
  validation_nationality_required: 'Please select nationality',
  signatory_info_add_email: '+ Add Email/Add another email',
  signatory_info_placeholder_enter_residential_address: 'Enter residential address',
  signatory_info_placeholder_enter_email: 'Enter Email',
  signatory_info_nationality_option_th: 'Thailand',
  signatory_info_nationality_option_sg: 'Singapore',
  signatory_info_nationality_option_other: 'Other',
  signatory_info_position_option_director: 'Director',
  signatory_info_position_option_auth_signatory: 'Authorized Signatory',
  signatory_info_position_option_other: 'Other',
  // Step 4: Shareholder Information
  shareholder_info_subtitle: 'Select ID Type',
  shareholder_info_id_type_etc: 'Etc.',
  shareholder_info_id_type_passport: 'Passport',
  shareholder_info_id_photo: 'ID Photo',
  shareholder_info_id_photo_front: 'ID Photo (Front)',
  shareholder_info_id_photo_back: 'ID Photo (Back)',
  shareholder_info_shareholding_ratio: 'Shareholding Ratio',
  shareholder_info_add_shareholder: '+ Add Shareholder/Add Another Shareholder',
  shareholder_info_placeholder_enter_shareholding_ratio: 'Enter Shareholding Ratio',
  // Step 5: Account Information
  account_info_subtitle: 'Select ID Type',
  account_info_id_type_etc: 'Etc.',
  account_info_id_type_passport: 'Passport',
  account_info_settlement_currency: 'Settlement Currency (USD or Local Currency)',
  account_info_settlement_account_location: 'Settlement Account Location',
  account_info_settlement_account_name: 'Settlement Account Name',
  account_info_settlement_account_number: 'Settlement Account Number',
  account_info_swift_code: 'Swift Code (Required for USD Settlement)',
  account_info_settlement_account_address: 'Settlement Account Address',
  account_info_settlement_account_proof: 'Settlement Account Proof',
  account_info_placeholder_enter_address_to_search: 'Enter Address to Search',
  account_info_placeholder_enter_name_to_search: 'Enter Name to Search',
  account_info_placeholder_enter_settlement_account_number: 'Enter Settlement Account Number',
  account_info_placeholder_enter_swift_code: 'Enter Swift Code',
  account_info_placeholder_enter_account_address_to_search: 'Enter Account Address to Search',
  account_info_currency_option_usd: 'USD',
  account_info_currency_option_thb: 'THB',
  account_info_currency_option_sgd: 'SGD',
  account_info_currency_option_other: 'Other',
  // Account page - bank fields
  account_info_bank_name: 'Bank Name',
  account_info_account_name: 'Account Name',
  account_info_account_number: 'Account Number',
  account_info_account_proof: 'Account Proof',
  account_info_placeholder_bank_name: 'Enter the Bank Name',
  account_info_placeholder_account_name: 'Enter the Bank Account Name',
  account_info_placeholder_account_number: 'Enter Account Number',
  save_draft_success: 'Draft saved successfully',
  saving: 'Saving...',
  save_failed: 'Save failed',
  upload_debounce_warning: 'Please do not upload repeatedly; try again shortly',
  upload_required: 'Please upload {field}',
  next_step: 'Next Step',
  submit_application: 'Submit Application',
  submit_success: 'Application submitted successfully',
  // Exit dialog
  exit_dialog_title: 'Complete Account Real-Name',
  exit_with_unsaved: 'You are about to exit the page and there are still some unsaved data. Do you want to save it?',
  first_step_required: 'Please complete the basic information in the first step first',
  cancel: 'Cancel',
  save: 'Save',
  // Pending popup
  pending_popup_title: 'Urgent Pending Pop Up Window',
  pending_popup_tip: 'You have yet to submit your identity verification documents. Please proceed to complete identity verification. (Please prepare the following documents in advance)',
  pending_rejected_tip: 'There are pending tasks for your account. To avoid affecting normal usage, please process them immediately.',
  pending_rejected_message: 'Your verification was rejected. Please modify and resubmit your information.',
  pending_business_type: 'Business Type',
  pending_todo: 'To Do',
  pending_operation: 'Operation',
  pending_business_account_verification: 'Account Verification',
  pending_todo_intro: 'You have not submitted your real-name information. Please proceed to real-name authentication. (Please prepare your information in advance.)',
  pending_item_1: 'Company basic information (contact details; operational status; transaction records, etc.)',
  pending_item_2: 'Company registration certificate, articles of association, tax documents, business permits/licences, etc.',
  pending_item_3: 'Company registrant information (passport-style photograph; identification number, etc.)',
  pending_item_4: 'Bank account details',
  pending_setup_now: 'Setup Now',
  // Verify Now popup
  verify_popup_title: 'Complete Account Real-Name',
  verify_main: 'Please complete account real-name authentication first',
  verify_sub: 'To ensure you can use PayCools services without any issues, please complete your account verification first',
  verify_now: 'Verify Now',
  verifying_title: 'Real-name verification in progress',
  verifying_main: 'Real-name verification in progress',
  verifying_sub: 'Your information is being reviewed. You will be able to use this feature once the review completes. Please be patient.',
  confirm: 'Confirm',
  rejection_title: 'Please comply the following requirements:',
  // validation messages
  validation_company_name_required: 'Please enter company name',
  validation_company_registration_required: 'Please enter company registration number',
  validation_date_of_incorporation_required: 'Please enter date of incorporation',
  validation_tax_id_required: 'Please enter tax identification number',
  validation_registration_address_required: 'Please enter business address',
  validation_brand_name_required: 'Please enter brand / trade name',
  validation_business_website_required: 'Please enter business website',
  validation_business_website_format: 'Please enter a URL starting with http:// or https://',
  validation_business_scope_required: 'Please enter business scope',
  validation_store_photo_required: 'Please upload office photo',
  validation_mcc_required: 'Please enter MCC',
  validation_monthly_transaction_required: 'Please enter monthly transaction amount',
  validation_company_type_required: 'Please select company type',
  validation_business_address_required: 'Please enter business address',
  validation_type_of_business_required: 'Please enter type of business',
  validation_exchange_name_required: 'Please enter exchange name',
  validation_stock_code_required: 'Please enter stock code',
  validation_bank_name_required: 'Please enter bank name',
  validation_account_name_required: 'Please enter account name',
  validation_account_number_required: 'Please enter account number',
  validation_account_proof_required: 'Please upload account proof',
  validation_idfront_required: 'Please upload ID front photo',
  validation_idback_required: 'Please upload ID back photo',
  validation_authorization_letter_required: 'Please upload authorization letter',
  validation_position_required: 'Please enter position',
  validation_all_fields_required: 'Please fill in all required fields',
  validation_length_20_30: 'Length must be between 20 and 30 characters',
  validation_length_100: 'Length must be between 1 and 100 characters',
  validation_length_500: 'Length must be between 1 and 500 characters',
  // Dashboard KYC banner
  dashboard_kyc_title: 'Account Verification',
  dashboard_kyc_subtitle: 'Complete real-name verification to unlock endless possibilities for your business.',
  dashboard_kyc_btn_text: 'Go to Verify',
  // Remove confirmation
  confirm_remove_file: 'Are you sure you want to remove {name}?',
  // File limit exceeded validation
  validation_file_limit_exceeded: 'The current limit is {limit}, please delete and upload again!'
}
